/* this might be a server component but is used by the component recognizer which has to be able to register server components */
'use client';

import { useTracking } from '@packages/tracking/src/hooks/useTracking/useTracking';
import { ComponentTypes } from '../../../interfaces';
import { useProcessHtmlLinks } from '../../hooks/useProcessHtmlLinks';
import { classes } from '../../utils/classes';
import { getFinalDangerouslyHTML } from '../../utils/getFinalDangerouslyHTML';
import { CmsTable } from '../CmsTable/CmsTable.client';
import { registerComponents } from '../ComponentRecognizer/componentRegistry';
import type { HtmlProps } from './types';

/**
 * Component that renders an HTML paragraph and styles its containing tags
 */
export const Html = ({ data, className }: HtmlProps) => {
  const {
    field_distance: distanceType,
    field_margin: margin,
    field_padding: padding,
    field_background_color: background = 'transparent',
    field_active_border: activeBorder = false,
    field_html_editor: htmlContent,
    field_text_align: textAlign = 'left',
    id,
  } = data;

  const getHtmlContent = getFinalDangerouslyHTML(htmlContent);
  const processHtmlLinks = useProcessHtmlLinks();
  const tmpHTML = processHtmlLinks(getHtmlContent ?? '');
  const finalHTML = tmpHTML.replace(/{--}/g, '&shy;');

  // delegate to cmsTable if table_json exists
  if ('table_json' in data) {
    return <CmsTable data={data} />;
  }
  return (
    <div
      key={id}
      className={classes(
        '_c_cms_html',
        activeBorder && 'border-color-info border-2',
        distanceType === 'variation-1' && 'px-3 lg:px-0',
        className,
      )}
      style={{
        ...(margin && { margin }),
        ...(distanceType !== 'variation-1' &&
          padding && {
            padding,
          }),
        textAlign,
        ...(background && { background }),
      }}
      dangerouslySetInnerHTML={{ __html: finalHTML }}
    />
  );
};

// Needed to run this component in Storybook and Jest tests. Register the component in a global componentRegistry object
registerComponents({
  [ComponentTypes.Html]: Html,
  [ComponentTypes.HtmlParagraph]: Html,
});
